// Utils
import { createApolloClient } from '../apollo-node-client';
import {
  RegionsListAllWithActiveSearchPageContentsDocument,
  RegionsListAllWithActiveSearchPageContentsQuery,
  RegionsListAllWithActiveSearchPageContentsQueryVariables,
} from '@gql';

type Options = {
  variables?: RegionsListAllWithActiveSearchPageContentsQueryVariables;
};

export const imperativeNodeRegionsListAllWithActiveSearchPageContentsQuery =
  async (options: Options) => {
    const apolloClient = createApolloClient();
    const response =
      await apolloClient.query<RegionsListAllWithActiveSearchPageContentsQuery>(
        {
          ...{
            query: RegionsListAllWithActiveSearchPageContentsDocument,
            ...options,
          },
        }
      );
    return response;
  };

export type RegionPartial =
  RegionsListAllWithActiveSearchPageContentsQuery['regionsListAllWithActiveSearchPageContents']['entries'][0];
